import * as React from "react";
import Axios from 'axios';

const authContext = React.createContext();

function useAuth()
{
    const [authstatus, setAuthstatus] = React.useState(false);
    const [token, setToken] = React.useState(false);
    const [interceptor, setInterceptor] = React.useState(false);
    const [user, setUser] = React.useState(false);
    const [slug, setSlug] = React.useState(false);
    const [personalToken, setPersonalToken] = React.useState('');
    const [personalTokenValid, setPersonalTokenValid] = React.useState(true);
    const [tracketTokenValid, setTracketTokenValid] = React.useState(true);
    const [csrfToken, setCsrfToken] = React.useState(null);
    
    return {
          authstatus,
          slug,
          token,
          user,
          personalToken,
          personalTokenValid,
          tracketTokenValid,
          csrfToken,
          interceptor,
          login(slug, user, token, personalToken = false, personalTokenValid = false, tracketTokenValid = false, csrfToken = null) {
                return new Promise((res) => {
                    setAuthstatus(true);
                    setToken(token);
                    setUser(user);
                    setSlug(slug);
                    setPersonalToken(personalToken);
                    setPersonalTokenValid(personalTokenValid);
                    setTracketTokenValid(tracketTokenValid);
                    setCsrfToken(csrfToken);
                    
                    Axios.defaults.headers.common['Authorization'] = 'Bearer '+token;
                    if(csrfToken!==null) Axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
                    
                    if(this.interceptor==false)
                    {
                        Axios.interceptors.response.use(response => {
                            return response;
                        }, error => {
                            const { config, response } = error;
                            //console.log('interceptr', error, config, response);
                            
                            if(response.status === 403 && ('error' in response.data) && response.data.error === 'csrf' && Axios.defaults.headers.common['X-CSRF-Token'] !== '')
                            {
                                Axios.defaults.headers.common['X-CSRF-Token'] = '';
                                
                                return Axios.get('/csrf_token', { 'params': {} } )
                                .then(response => {
                                    
                                    //console.log('new csrf', response);
                                    Axios.defaults.headers.common['X-CSRF-Token'] = response.data.csrf_token;
                                    config.headers['X-CSRF-Token'] = response.data.csrf_token;
                                    
                                    return Axios(config);
                                    
                                }).catch(err => {
                                    console.log('csrf regenerate error', err, err.response);

                                    if('error_message' in err.response.data)
                                    {
                                        monday.execute("notice", { 
                                            message: err.response.data.error_message,
                                            type: "error", // or "error" (red), or "info" (blue)
                                            timeout: 30000,
                                        });
                                    }
                                    
                                    return Promise.reject(error);
                                });
                            }
                            
                            if(response.status === 401)
                            {
                                setAuthstatus(false);
                                setToken(false);
                                setUser(false);
                                setSlug(false);
                                setPersonalToken(false);
                                setPersonalTokenValid(false);
                                setTracketTokenValid(false);
                                Axios.defaults.headers.common['Authorization'] = '';
                                Axios.defaults.headers.common['X-CSRF-Token'] = '';
                            }
                            
                            return Promise.reject(error);
                        });
                        setInterceptor(true);
                    }
                    //console.log('login', JSON.parse(JSON.stringify(this)), JSON.parse(JSON.stringify(Axios.interceptors)));
                    res();
                });
          },
          setPersonalToken(value) {
              return new Promise((res) => {
                  setPersonalToken(value);
                  res();
              });
          },
          setPersonalTokenValid(value) {
              return new Promise((res) => {
                  setPersonalTokenValid(value);
                  res();
              });
          },
          setTracketTokenValid(value) {
              return new Promise((res) => {
                  setTracketTokenValid(value);
                  res();
              });
          },
          logout() {
            return new Promise((res) => {
                //console.log('logout', JSON.parse(JSON.stringify(that)));
                setAuthstatus(false);
                setToken(false);
                setUser(false);
                setSlug(false);
                setPersonalToken('');
                setPersonalTokenValid(true);
                setTracketTokenValid(false);
                setCsrfToken(null);
                Axios.defaults.headers.common['Authorization'] = '';
                Axios.defaults.headers.common['X-CSRF-Token'] = '';
                res();
            });
          },
    };
}

export function AuthProvider({ children })
{
    const auth = useAuth();

    return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export default function AuthConsumer()
{
    return React.useContext(authContext);
}